import translate from '@translate';
import React, { FC } from 'react';
import FileUpload, { FilesPropType } from 'src/components/FileUpload';
import { styled } from '@mui/material';
import { ReceivingType } from 'src/types/receiving';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';
import { FileType } from 'src/types/file';
import { RECEIVING_FILE_ATTACHMENT_TYPE, RECEIVING_FILE_DESCRIPTION_MAX_LENGTH } from 'src/utils/receivingFiles';
import ReceivingFilesList from './ReceivingFilesList';

export interface ReceivingFilesBlockPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ReceivingType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
    isAttributeEditDisabled: (key: string) => boolean;
    skladonUser?: number;
}

const Block = styled('div')(() => ({
    '& .MuiTextField-root label': {
        display: 'block',
    },
}));

const ReceivingFilesBlock: FC<ReceivingFilesBlockPropsType> = (props) => {
    const handleFiles = (value: FilesPropType, error: boolean) => {
        props.onChange('FILES', value, error);
    };

    const handleDescription = (file: FileType, description: string) => {
        const clipped = description.slice(0, RECEIVING_FILE_DESCRIPTION_MAX_LENGTH);
        const list = props.editData.FILES || [];
        const next = list.map((f) =>
            f === file || (f.id != null && file.id != null && f.id === file.id)
                ? { ...f, description: clipped, type: RECEIVING_FILE_ATTACHMENT_TYPE }
                : f
        );
        props.onChange('FILES', next, false);
    };

    const handleDeleteFile = (file: FileType) => {
        const list = props.editData.FILES || [];
        props.onChange(
            'FILES',
            list.filter((oldFile) => oldFile !== file),
            false
        );
    };

    const filesDisabled = props.isAttributeEditDisabled('FILES');

    return (
        <Block>
            <FileUpload
                label={translate('receivingDetail.filesTitle')}
                files={props.editData.FILES}
                onChange={handleFiles}
                name="FILES"
                error={!!props.editErrors.FILES}
                height={130}
                disabled={filesDisabled}
                multiple
                displayFilesList={false}
            />
            <ReceivingFilesList
                files={props.editData.FILES}
                disabled={filesDisabled}
                onDescriptionChange={filesDisabled ? undefined : handleDescription}
                onDeleteFile={handleDeleteFile}
                skladonUser={props.skladonUser}
            />
        </Block>
    );
};

export default ReceivingFilesBlock;
